/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.11.0
 * @since 1.0.0
 */
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { appHistoryPush } from '@modules/app/appHistory';
import { makeSelectTranslationCommon } from '@modules/internationalization/intSelectors';
import { makeSelectorModalIsOpen } from '@modules/modal/modalSelectors';
import { AccessComponentKeyEnum } from '@modules/role/constants/guard/guardConstants';
import { makeSelectGuardComponentEnabled } from '@modules/role/selectors/guardSelector';
import { wizardStorageClearStepsAction } from '@modules/wizard/wizardActions';
import { EWizardName } from '@modules/wizard/wizardConstants';
import { IRootReducer } from '@reducers/rootReducer';
import { ExternalRoutePath, openExternalRoute } from '@routes/constants/externalRoutes';
import { RoutePath } from '@routes/constants/routesConstants';

import { ICommonTranslation } from '../../../../modules/internationalization/types';
import { Button } from '../../../common';
import { FooterModalStyled, FooterModalTextStyled, FooterModalTitleStyled } from './styled/footerModalStyled';


export const STATUS_OK = 'OK';

interface IChangeRoleModalConnectedProps {
    isWizardChangeRoleEnabled: boolean;
    modalOpen: boolean;
    translation: ICommonTranslation;
}

export interface IChangeRoleModalProps {
    message: string;
    onCloseModal: () => void;
    status: string;
}

type TChangeRoleModal = IChangeRoleModalProps & IChangeRoleModalConnectedProps;

const ChangeRoleModal = (props: TChangeRoleModal) => {
    const handleClose = (): void => {
        if (props.status === STATUS_OK) {
            wizardStorageClearStepsAction({ wizardName: EWizardName.CHANGE_ROLE });
            props.isWizardChangeRoleEnabled
                ? appHistoryPush(RoutePath.wizardChangeRoleFromSubscribers)
                : openExternalRoute(ExternalRoutePath.mobileRole);
        }
        props.onCloseModal();
    };
    return (
        <FooterModalStyled
            data-component={'modal-popup'}
            data-name={'change-role'}>
            <FooterModalTitleStyled className="mb-3">
                {props.translation.modal.attention + '!'}
            </FooterModalTitleStyled>
            <FooterModalTextStyled className="mb-5">
                {props.message}
            </FooterModalTextStyled>
            <Button
                data-modal-attention="close-button"
                kind="medium"
                onClick={handleClose}
            >
                {props.translation.modal.ok}
            </Button>
        </FooterModalStyled>
    );
};

const mapStateToProps = createStructuredSelector<IRootReducer, IChangeRoleModalConnectedProps>({
    isWizardChangeRoleEnabled: makeSelectGuardComponentEnabled(AccessComponentKeyEnum.PageWizardChangeRole),
    modalOpen: makeSelectorModalIsOpen(),
    translation: makeSelectTranslationCommon(),
});

export default connect(mapStateToProps)(ChangeRoleModal);
